import i18n from 'i18next';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import {initReactI18next} from 'react-i18next';

import {formatDate} from 'utils/date';

import bsTranslation from './bs.json';
import enUsTranslation from './en-us.json';
import frTranslation from './fr.json';
import ruTranslation from './ru.json';
import uaTranslation from './ua.json';

import {locales, Locales} from './index';

// Translation localization
i18n.use(initReactI18next).init({
    debug: false,
    lng: Object.keys(locales).find((l) => l === localStorage.lang) || Locales.en,
    fallbackLng: Locales.en,
    resources: {
        [Locales.en]: {translation: enUsTranslation},
        [Locales.bs]: {translation: bsTranslation},
        [Locales.ua]: {translation: uaTranslation},
        [Locales.ru]: {translation: ruTranslation},
        [Locales.fr]: {translation: frTranslation},
    },
    interpolation: {
        escapeValue: false,
        format: (value, format?: string): string => {
            if (value instanceof Date) {
                return formatDate(value, format);
            }

            return value;
        },
    },
    detection: {
        order: [
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'htmlTag',
            'path',
            'subdomain',
            // 'navigator',
        ],
    },
});

// Datepicker localization
Object.entries(locales).forEach(([key, value]) => registerLocale(key, value));
setDefaultLocale(Locales.en);
